import { MerchantVendorBaseResponseModel, MerchantVendorCategoryResponseModel, MerchantVendorCredentialModel, MerchantVendorResponseModel, MerchantVendorServiceResponseModel, UpdateMerchantVendorRequestModel } from "../../../models/MerchantVendor";
import { Result } from "../../../models/Result";
import { httpService } from "../../HttpService";

class MerchantVendorApiService {
  path: string = "MerchantVendor";

  syncMerchantVendors = async (merchantId: number): Promise<Result<void>> =>
    await httpService.get<void>(`/${this.path}/${merchantId}/sync-merchant-vendors`);

  getVendors = async (merchantId: number): Promise<Result<MerchantVendorResponseModel[]>> =>
    await httpService.get<MerchantVendorResponseModel[]>(`/${this.path}/${merchantId}/get-merchant-vendors`);

  getOwnVendors = async (): Promise<Result<MerchantVendorResponseModel[]>> =>
    await httpService.get<MerchantVendorResponseModel[]>(`/${this.path}/get-own-merchant-vendors`);

  updateVendor = async (model: UpdateMerchantVendorRequestModel): Promise<Result<void>> =>
    await httpService.put<void>(`/${this.path}/update-merchant-vendor`, model);

  getVendorCategories = async (): Promise<Result<MerchantVendorCategoryResponseModel[]>> =>
    await httpService.get<MerchantVendorCategoryResponseModel[]>(`/${this.path}/get-merchant-vendor-categories`);

  updateVendorCategory = async (model: UpdateMerchantVendorRequestModel): Promise<Result<void>> =>
    await httpService.put<void>(`/${this.path}/update-merchant-vendor-category`, model);

  getVendorServices = async (id: number): Promise<Result<MerchantVendorServiceResponseModel[]>> =>
    await httpService.get<MerchantVendorServiceResponseModel[]>(`/${this.path}/${id}/merchant-vendor-services`);

  updateVendorService = async (model: UpdateMerchantVendorRequestModel): Promise<Result<void>> =>
    await httpService.put<void>(`/${this.path}/update-merchant-vendor-service`, model);

  getVendorCredentials = async (id: number): Promise<Result<MerchantVendorCredentialModel[]>> =>
    await httpService.get<MerchantVendorCredentialModel[]>(`/${this.path}/${id}/merchant-vendor-credentials`);

  updateVendorCredentials = async (model: MerchantVendorCredentialModel): Promise<Result<void>> =>
    await httpService.put<void>(`/${this.path}/update-merchant-vendor-credential`, model);



}

const merchantVendorApiService = new MerchantVendorApiService();

export { merchantVendorApiService };